import React from 'react'
import {createIcon} from '@chakra-ui/react'

// TODO: These icons need to be renamed and the rectangle elements should be shared
// between both filter icons for consistency

export const FilterListIcon = createIcon({
  displayName: 'FilterListIcon',
  viewBox: '0 0 24 24',
  path: (
    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="black" />
  ),
})

export const FilterIcon = createIcon({
  displayName: 'FilterIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle
        cx="12"
        cy="12"
        r="11"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="2"
      />
      <rect x="6" y="8" width="12" height="2" fill="currentColor" />
      <rect x="8" y="12" width="8" height="2" fill="currentColor" />
      <rect x="10" y="16" width="4" height="2" fill="currentColor" />
    </>
  ),
})
